export default __webpack_public_path__ + "static/media/NYSE.4250523b.png";